<app-breadcrumb [title]="'Vacant Posts'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
            <a [routerLink]="['/region/sanctioned-posts/vacant-posts']" class="btn btn-outline-primary">Cancel</a>
          </div>
        </div>
        <div class="card-body">
          <form [formGroup]="vacantPostForm" (ngSubmit)="save()">
            <input type="hidden" formControlName="id">
            <input type="hidden" formControlName="financialYearId">
            <input type="hidden" formControlName="sanctionedPostId">
            <input type="hidden" formControlName="regionId">
            <input type="hidden" formControlName="isActive">

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="stateId">State</label>
                  <select MyInput formControlName="stateId" class="form-select"
                    (change)="getDistricts($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of states" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="stateId" errorKey="required">State is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="districtId">District</label>
                  <select MyInput formControlName="districtId" class="form-select"
                    (change)="getSchools($event.target.value)">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of districts" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="districtId" errorKey="required">District is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="schoolId">School</label>
                  <select MyInput formControlName="schoolId" class="form-select" (change)="setVacantPost()">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of schools" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="schoolId" errorKey="required">School is required.</my-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="designationId">Designation</label>
                  <select MyInput formControlName="designationId" class="form-select" (change)="setVacantPost()">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of designations" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="designationId" errorKey="required">Designation is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="vacancyTypeId">Vacancy Type</label>
                  <select MyInput formControlName="vacancyTypeId" (change)="loadVacancyFields($event.target.value)" class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of vacancyTypes" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="vacancyTypeId" errorKey="required">Vacancy Type is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="noOfPost">No. Of Post</label>
                  <input MyInput formControlName="noOfPost" class="form-control" />
                  <my-error controlName="noOfPost" errorKey="required">No. Of Post is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="noOfFilled">No. Of Filled Post</label>
                  <input MyInput formControlName="noOfFilled" class="form-control" />
                  <my-error controlName="noOfFilled" errorKey="required">No. Of Filled Post is required.</my-error>
                </div>
              </div>
              <div *ngIf="this.isShalaId" class="col-md-4">
                <label class="form-label" for="shalaId">Shala Darpan (PIS) ID</label>
                <input type="text" class="form-control" MyInput placeholder="Shala Darpan (PIS) ID"
                  formControlName="shalaId" id="shalaId">
                <my-error controlName="shalaId" errorKey="required">Shala Darpan (PIS) ID is required.</my-error>
                <my-error controlName="shalaId" errorKey="pattern">Enter valid 10 Or 11 digit Shala Darpan (PIS) ID.
                </my-error>
              </div>
              <div *ngIf="this.isDeemedDDList" class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="transferCategoryId">Reason Of The Protected Deemed</label>
                  <select MyInput formControlName="transferCategoryId" (change)="loadDoc($event.target.value)"
                    class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of transferCategory" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="transferCategoryId" errorKey="required">Reason Of The Protected Deemed is
                    required.
                  </my-error>
                </div>
              </div>
            </div>
            <div *ngIf="this.isDocument" class="row">
              <div class="col-md-4">
                <input class="form-control" type="file" #inputDoc
                  (change)="handleFileInput($event.target.files);OnSubmit(inputDoc)">
                <my-error controlName="documentId" errorKey="required">File is required.</my-error>
              </div>
              <div class="col-md-4" *ngIf="vacantPost?.document">
                <a target="_blank" [attr.href]="vacantPost?.document?.mediaUrl" class="btn btn-success btn-sm">Uploaded
                  Document</a>
              </div>
              <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
                <div [style.width]="barWidth + '%'"
                  class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <button class="btn btn-primary rounded-0 mr-2" [disabled]="!vacantPostForm.valid || loading"
                type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
            </div>
          </form>

        </div>
      </div>

    </div>
  </div>
</div>